// extracted by mini-css-extract-plugin
export default {"Body":"App_Body__6VpIe","Body__white":"App_Body__white__2xluT"};